define("shared/components/shared-carousel", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "ember-concurrency-decorators", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _emberConcurrencyDecorators, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"ember-concurrency-decorators",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cPM--videoThumbnailPreview__mediaWrapper carousel slide" {{did-insert this.addListener}} {{will-destroy this.removeListener}} ...attributes>
    {{yield
      (hash
      indicators=(component "carousel-indicators" carouselMediaItems=@carouselMediaItems targetId=this.elementId index=this.index updateIndex=(action "clickedUpdate"))
      inner=(component "carousel-inner" carouselMediaItems=@carouselMediaItems index=this.index isInstagram=@isInstagram)
      controls=(component "carousel-controls" carouselMediaItems=@carouselMediaItems targetId=this.elementId index=this.index updateIndex=(action "limitedUpdate"))
      currentIndex=this.index
      )}}
  </div>
  
  */
  {
    "id": "S5bE84o+",
    "block": "[[[11,0],[24,0,\"cPM--videoThumbnailPreview__mediaWrapper carousel slide\"],[17,1],[4,[38,0],[[30,0,[\"addListener\"]]],null],[4,[38,1],[[30,0,[\"removeListener\"]]],null],[12],[1,\"\\n  \"],[18,4,[[28,[37,3],null,[[\"indicators\",\"inner\",\"controls\",\"currentIndex\"],[[50,\"carousel-indicators\",0,null,[[\"carouselMediaItems\",\"targetId\",\"index\",\"updateIndex\"],[[30,2],[30,0,[\"elementId\"]],[30,0,[\"index\"]],[28,[37,5],[[30,0],\"clickedUpdate\"],null]]]],[50,\"carousel-inner\",0,null,[[\"carouselMediaItems\",\"index\",\"isInstagram\"],[[30,2],[30,0,[\"index\"]],[30,3]]]],[50,\"carousel-controls\",0,null,[[\"carouselMediaItems\",\"targetId\",\"index\",\"updateIndex\"],[[30,2],[30,0,[\"elementId\"]],[30,0,[\"index\"]],[28,[37,5],[[30,0],\"limitedUpdate\"],null]]]],[30,0,[\"index\"]]]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"&attrs\",\"@carouselMediaItems\",\"@isInstagram\",\"&default\"],false,[\"did-insert\",\"will-destroy\",\"yield\",\"hash\",\"component\",\"action\"]]",
    "moduleName": "shared/components/shared-carousel.hbs",
    "isStrictMode": false
  });

  let SharedCarousel = (_class = class SharedCarousel extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "index", _descriptor, this);
    }

    addListener(element) {
      this.carouselListener = element.addEventListener('slide.bs.carousel', event => this._debouncedIndexUpdate.perform(event.relatedTarget.dataset.index));
    }

    removeListener(element) {
      element.removeEventListener('slide.bs.carousel', this.carouselListener);
    }

    limitedUpdate(index) {
      const newIndex = this.index + index;

      this._debouncedIndexUpdate.perform(newIndex);
    }

    clickedUpdate(index) {
      this._debouncedIndexUpdate.perform(index);
    }

    *_debouncedIndexUpdate(index) {
      this.index = index;
      this.args.updateIndex(index);
      yield;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "index", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.args.index;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addListener", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeListener", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "limitedUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "limitedUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickedUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clickedUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_debouncedIndexUpdate", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "_debouncedIndexUpdate"), _class.prototype)), _class);
  _exports.default = SharedCarousel;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedCarousel);
});